import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import StockSetsProducts from "features/Stock/StockSetProduct/components/StockSetProducts";
import React from "react";

const StockSetProduct = () => {
  const { setSortOptions, setSelectedSortValue, selectedSortValue, sortOptions } = React.useContext(SortContext);
  const { setBreadCrumbLock, setSearchPlaceHolder } = useGlobalContext();

  React.useEffect(() => {
    setBreadCrumbLock(true);
    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Make Date (Oldest to Newest)", sortBy: "Make Date", order: "asc" },
      { id: 6, name: "Make Date (Newest to Oldest)", sortBy: "Make Date", order: "desc" },
      { id: 7, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 8, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 9, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 10, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
      {
        id: 11,
        name: "Sales (Low to High)",
        sortBy: "Sales",
        order: "asc",
      },
      {
        id: 12,
        name: "Sales (High to Low)",
        sortBy: "Sales",
        order: "desc",
      },
    ]);

    setSearchPlaceHolder("Search by Jewel Code or Design Number");

    return () => {
      setSearchPlaceHolder("Search");
      setBreadCrumbLock(false);
      setSortOptions([]);
      setSelectedSortValue(null);
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  React.useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  return <StockSetsProducts />;
};

export default StockSetProduct;
